import React from 'react'
import { FormCheckbox } from '@myxplor/forms'

export const EducatorDisclaimer = ({ onChange, value = false }) => (
  <fieldset>
    <legend>Disclaimer</legend>
    <FormCheckbox
      key="declaration_signed"
      name="declaration_signed"
      label="Educator Disclaimer"
      hint="I declare that the Additional Educator/s listed were engaged to
              increase the staff to child ratio above that required by state or
              territory licensing and regulatory requirements."
      value={value}
      onChange={onChange}
      compact
      required
    />
  </fieldset>
)

export default EducatorDisclaimer



// WEBPACK FOOTER //
// ./src/iss-case-claims/details/case-claim/form/educator-disclaimer.jsx